import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo, useContext, useEffect, useMemo, useState } from 'react';
import { Box } from '@chakra-ui/react';
import { hasValue, useT } from '@progress-fe/core';
import { Dialog } from '../../base';
import { JsFieldError, JsFieldInspector } from '../../jsFormBase';
import { useJsFieldFormData } from '../../../hooks';
import { JsFormConfigContext } from '../../../contexts';
import { BinaryCoeffsTable } from './components';
/**
 * Component renders "/schemas/jsf-binary-coeffs" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is TFormData.
 */
const BinaryCoeffsJsFieldFC = (props) => {
    const { isInspector, components, runCallback } = useContext(JsFormConfigContext) || {};
    const { pureList = [] } = components || {};
    const [isDialog, setIsDialog] = useState(false);
    const { t } = useT();
    const formData = useMemo(() => (hasValue(props.formData) ? props.formData : null), [props.formData]);
    const { fieldConfig, fieldValues, onChangeFieldValues, onChangeFieldConfig } = useJsFieldFormData({
        config: formData?.fieldConfig ?? null,
        values: formData?.fieldValues ?? null,
        onChange: props.onChange
    });
    useEffect(() => {
        onChangeFieldConfig(formData?.fieldConfig);
    }, [formData?.fieldConfig, onChangeFieldConfig]);
    const handleChangeValue = (rootKey, key, value) => {
        if (fieldValues) {
            const fieldValuesCopy = structuredClone(fieldValues);
            fieldValuesCopy[rootKey][key] = value;
            fieldValuesCopy[key][rootKey] = value;
            onChangeFieldValues(fieldValuesCopy);
        }
    };
    const handleBipsCallback = async () => {
        const formDataResult = await runCallback?.(fieldConfig?.callbackCode ?? '');
        if (hasValue(formDataResult)) {
            onChangeFieldConfig(formDataResult.fieldConfig);
            onChangeFieldValues(formDataResult.fieldValues);
        }
    };
    const handleToggleDialog = () => {
        setIsDialog(!isDialog);
    };
    if (!fieldConfig || !fieldValues) {
        return _jsx(JsFieldError, { propName: props.name });
    }
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsxs(Box, { "data-testid": "BinaryCoeffsJsField-test", "data-name": props.name, w: isDialog ? '100%' : '423px', p: '0 4px 2px 0', children: [_jsx(BinaryCoeffsTable, { isDialog: isDialog, pureList: pureList, fieldValues: fieldValues, isReadOnly: props.schema.readOnly, hasCallback: !!fieldConfig.callbackCode, onChangeValue: handleChangeValue, onCalcCoeffs: handleBipsCallback, onToggleDialog: handleToggleDialog }), isDialog && (_jsx(Dialog, { title: t('jsfields.BinaryCoeffs.name'), onClose: handleToggleDialog, children: _jsx(BinaryCoeffsTable, { isDialog: isDialog, pureList: pureList, fieldValues: fieldValues, isReadOnly: props.schema.readOnly, hasCallback: !!fieldConfig.callbackCode, onChangeValue: handleChangeValue, onCalcCoeffs: handleBipsCallback, onToggleDialog: handleToggleDialog }) }))] }) }));
};
export const BinaryCoeffsJsField = memo(BinaryCoeffsJsFieldFC);
//# sourceMappingURL=BinaryCoeffsJsField.js.map